import React from "react";
import Footer from "./Footer";
import { useState,useEffect } from "react";

export default function ContactPage() {
   useEffect(()=>{
    window.scrollTo(0,0);
   },[])
  const [formData, setFormData] =useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] =useState(false);
  const [submitStatus, setSubmitStatus] =useState("idle");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("idle");

    const mailto = `mailto:info@panjshiremeraldvault.com?subject=${encodeURIComponent(
      formData.subject || "Contact Form Submission"
    )}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    )}`;

    window.location.href = mailto;

    setTimeout(() => {
      setFormData({ name: "", email: "", subject: "", message: "" });
      setIsSubmitting(false);
      setSubmitStatus("success");
    }, 1000);
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f9fafb" }}>

      {/* Main */}
      <main style={{ padding: "3rem 1rem" }}>
        <div style={{ maxWidth: "80rem", margin: "0 auto" }}>
          {/* Title */}
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <div
              style={{
                display: "inline-block",
                padding: "0.25rem 1rem",
                backgroundColor: "#d1fae5",
                color: "#065f46",
                borderRadius: "9999px",
                fontSize: "0.875rem",
                fontWeight: "500",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                marginBottom: "1rem",
              }}
            >
              Get In Touch
            </div>
            <h2 style={{ fontSize: "3rem", fontWeight: "bold", color: "#111827", marginBottom: "1rem" }}>
              Contact Us
            </h2>
            <p style={{ color: "#4b5563", fontSize: "1.125rem", maxWidth: "42rem", margin: "0 auto" }}>
              We're here to help. Reach out to us through any of the following channels.
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "2rem",
            }}
          >
            {/* Contact Cards */}
            <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
              {/* Call */}
              <a
                href="tel:+93729599599"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                  border: "1px solid #e5e7eb",
                  padding: "1.5rem",
                  textDecoration: "none",
                  transition: "all 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 10px 15px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    width: "3.5rem",
                    height: "3.5rem",
                    borderRadius: "9999px",
                    backgroundColor: "#065f46",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "1.25rem",
                    transition: "background-color 0.3s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#064e3b")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#065f46")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontSize: "1.25rem", fontWeight: "600", color: "#111827", marginBottom: "0.5rem" }}>
                    Call Us
                  </h3>
                  <p style={{ color: "#065f46", fontSize: "1.125rem", fontWeight: "500" }}>
                    +93 72 959 9599
                  </p>
                  <p style={{ color: "#6b7280", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                    Available 24/7
                  </p>
                </div>
              </a>

              {/* Email */}
              <a
                href="mailto:info@panjshiremeraldvault.com"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                  border: "1px solid #e5e7eb",
                  padding: "1.5rem",
                  textDecoration: "none",
                  transition: "all 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 10px 15px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    width: "3.5rem",
                    height: "3.5rem",
                    borderRadius: "9999px",
                    backgroundColor: "#065f46",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "1.25rem",
                    transition: "background-color 0.3s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#064e3b")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#065f46")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontSize: "1.25rem", fontWeight: "600", color: "#111827", marginBottom: "0.5rem" }}>
                    Email Us
                  </h3>
                  <p style={{ color: "#065f46", fontSize: "1.125rem", fontWeight: "500", wordBreak: "break-all" }}>
                    info@panjshiremeraldvault.com
                  </p>
                  <p style={{ color: "#6b7280", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                    We'll respond within 24 hours
                  </p>
                </div>
              </a>

              {/* Visit */}
              <a
                href="https://www.google.com/maps/search/?api=1&query=Ansari+Square+Shahr-e-Naw+Kabul+Afghanistan"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  backgroundColor: "#fff",
                  borderRadius: "1rem",
                  border: "1px solid #e5e7eb",
                  padding: "1.5rem",
                  textDecoration: "none",
                  transition: "all 0.3s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                  e.currentTarget.style.boxShadow = "0 10px 15px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    width: "3.5rem",
                    height: "3.5rem",
                    borderRadius: "9999px",
                    backgroundColor: "#065f46",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "1.25rem",
                    transition: "background-color 0.3s",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#064e3b")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#065f46")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="28"
                    height="28"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="white"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontSize: "1.25rem", fontWeight: "600", color: "#111827", marginBottom: "0.5rem" }}>
                    Visit Us
                  </h3>
                  <p style={{ color: "#374151", fontSize: "1.125rem", fontWeight: "500" }}>
                    Ansari Square, Shahr-e-Naw, Kabul, Afghanistan
                  </p>
                  <p style={{ color: "#6b7280", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                    Sat-Tue: 24h
                  </p>
                </div>
              </a>
            </div>

            {/* Form */}
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "1rem",
                boxShadow: "0 10px 15px rgba(0,0,0,0.1)",
                padding: "2rem",
                border: "1px solid #e5e7eb",
              }}
            >
              <h3 style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "1.5rem", color: "#111827" }}>
                Send Us a Message
              </h3>

              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
                <div>
                  <label
                    htmlFor="name"
                    style={{
                      display: "block",
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Your Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid #d1d5db",
                      outline: "none",
                      transition: "all 0.3s",
                    }}
                    placeholder="John Doe"
                    disabled={isSubmitting}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#059669";
                      e.target.style.boxShadow = "0 0 0 3px rgba(5,150,105,0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                <div>
                  <label
                    htmlFor="email"
                    style={{
                      display: "block",
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid #d1d5db",
                      outline: "none",
                      transition: "all 0.3s",
                    }}
                    placeholder="john@example.com"
                    disabled={isSubmitting}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#059669";
                      e.target.style.boxShadow = "0 0 0 3px rgba(5,150,105,0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                <div>
                  <label
                    htmlFor="subject"
                    style={{
                      display: "block",
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid #d1d5db",
                      outline: "none",
                      transition: "all 0.3s",
                    }}
                    placeholder="How can we help?"
                    disabled={isSubmitting}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#059669";
                      e.target.style.boxShadow = "0 0 0 3px rgba(5,150,105,0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                <div>
                  <label
                    htmlFor="message"
                    style={{
                      display: "block",
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      color: "#374151",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Your Message *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: "100%",
                      padding: "0.75rem 1rem",
                      borderRadius: "0.5rem",
                      border: "1px solid #d1d5db",
                      outline: "none",
                      transition: "all 0.3s",
                      resize: "none",
                    }}
                    placeholder="Tell us about your inquiry..."
                    disabled={isSubmitting}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#059669";
                      e.target.style.boxShadow = "0 0 0 3px rgba(5,150,105,0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#d1d5db";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                {submitStatus === "success" && (
                  <div
                    style={{
                      padding: "1rem",
                      backgroundColor: "#ecfdf5",
                      border: "1px solid #a7f3d0",
                      borderRadius: "0.5rem",
                      color: "#065f46",
                      fontSize: "0.875rem",
                    }}
                  >
                    Your email client should open shortly. If not, please email us directly.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    width: "100%",
                    backgroundColor: "#065f46",
                    color: "#fff",
                    fontWeight: "600",
                    padding: "1.5rem",
                    borderRadius: "0.5rem",
                    border: "none",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    opacity: isSubmitting ? 0.5 : 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.5rem",
                    transition: "all 0.3s",
                  }}
                  onMouseEnter={(e) =>
                    !isSubmitting && (e.currentTarget.style.backgroundColor = "#064e3b")
                  }
                  onMouseLeave={(e) =>
                    !isSubmitting && (e.currentTarget.style.backgroundColor = "#065f46")
                  }
                >
                  {isSubmitting ? (
                    "Sending..."
                  ) : (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                        />
                      </svg>
                      Send Message
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer/>
    </div>
  );
}